export default [
    {
        path: '/users',
        name: 'Users',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            isCentralRoute: true,
            title: 'Users',
        },
        components: {
            default: () => import('@views/users/UsersIndex.vue'),
        },
        children: [],
    },
    {
        path: '/tenants/:tenantId/users',
        name: 'TenantUsers',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            isCentralRoute: true,
            title: 'Tenant users',
        },
        components: {
            default: () => import('@views/users/UsersIndex.vue'),
        },
        children: [],
    },
    {
        path: '/tenants/:tenantId/users/create',
        name: 'TenantUsersCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            isCentralRoute: true,
        },
        components: {
            default: () => import('@views/users/UsersCreate.vue'),
        },
    },
    {
        path: '/tenants/:tenantId/users/:id/edit',
        name: 'TenantUsersEdit',
        props: {
            default: (route) => ({ tenantId: route.params.tenantId }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            isCentralRoute: true,
        },
        components: {
            default: () => import('@views/users/UsersEdit.vue'),
        },
    },
];
